import { PAYMENT_REQUEST_CLAIMS } from '@src/graphql/queries/paymentRequest';
import { PaymentRequestStatus } from '@src/types';
import { usePaginatedFetchItems } from 'pe-core-frontend';
import { useCallback, useMemo } from 'react';
export var ClaimsTab;
(function (ClaimsTab) {
    ClaimsTab["PENDING"] = "pending";
    ClaimsTab["INFO_REQUESTED"] = "info_requested";
    ClaimsTab["HOLD"] = "hold";
    ClaimsTab["PROCESSED"] = "processed";
    ClaimsTab["CONFIG"] = "config";
})(ClaimsTab || (ClaimsTab = {}));
export const usePaymentRequestClaims = ({ filter, tab, initialPageSize = 10, }) => {
    const statuses = useMemo(() => {
        switch (tab) {
            case ClaimsTab.PENDING:
                return [PaymentRequestStatus.DOCUMENT_REVIEW];
            case ClaimsTab.HOLD:
                return [PaymentRequestStatus.ON_HOLD];
            case ClaimsTab.INFO_REQUESTED:
                return [PaymentRequestStatus.INFO_REQUESTED];
            case ClaimsTab.PROCESSED:
                return [
                    PaymentRequestStatus.READY_FOR_PAYMENT,
                    PaymentRequestStatus.CLOSED,
                    PaymentRequestStatus.APPROVED,
                    PaymentRequestStatus.REJECTED,
                    PaymentRequestStatus.EXPIRED,
                ];
        }
    }, [tab]);
    const { items, total, page, setPage, pageSize, setPageSize, error, loading, orderBy, orderByDir, setOrderBy, setOrderByDir, refetch, } = usePaginatedFetchItems({
        fetchQuery: PAYMENT_REQUEST_CLAIMS,
        dataProp: 'paymentRequestClaims',
        initialPageSize,
        initialSort: {
            orderBy: tab === ClaimsTab.PROCESSED ? 'processedDate' : 'submittedAt',
            orderByDir: tab === ClaimsTab.PROCESSED ? 'desc' : 'asc',
        },
        spec: {
            ...filter,
            statuses,
        },
    });
    const paymentRequests = useMemo(() => (items || []), [items]);
    const find = useCallback((id) => paymentRequests.find(req => req.id === id), [paymentRequests]);
    return {
        paymentRequests,
        page,
        setPage,
        pageSize,
        setPageSize,
        total,
        error,
        loading,
        find,
        orderBy,
        orderByDir,
        setOrderBy,
        setOrderByDir,
        refetch,
    };
};
